export default {
  retailerId: "Customer",
  billingLocation: "Bill To",
  shippingLocationId: "Ship To",
  purchaseOrder: "PO #",
  status: "Status",
  email: "Email",
  accountType: "Account Type",
  storeType: "Store Type",
  transactionType: "Transaction Type",
  federalTaxId: "Resale ID",
  sourceId: "Order Source",
  paymentTermsId: "Terms",
  priceList: "Price List",
  vendorId: "Vendor",
  buyer: "Contact/Buyer",
  shippingMethodId: "Ship Via",
  storeCategory: false,
  shipOn: "Ship Date",
  cancelOn: "Cancel Date",
  invoiceDate: "Invoice Date",
  orderedOn: "Order Date",
  companyName: "Name",
  note: "Note",
  vendorNote: false,
  deliveryNote: false,
  shippingNote: false,
  tagFor: false,
  cartName: "Order Name",
  discount: "Discount",
  invoiceNumber: "Invoice #",
  orderNumber: "Order #",
  warehouse: false,
  container: false,
  division: false,
  bol: false,
  //credit memo
  cmAmount: false,
  reason: false,
  description: false,
  // line
  availableOn: false,
  lineNote: "Note",
  lineDiscount: "Discount (%)",
  lineVendorId: false,
  reasonCode: "Reason Code",
  SaveOrderLabel: "Save",
  SavingOrderLabel: "Saving..."
};
